<template>
  <m-radio
    :checked="selectedVal === value"
    :name="name"
    v-bind="$attrs"
    v-on="$listeners"
    @click="handleRadioClick(value)" />
</template>
<script>
import Vue from 'vue'
import MRadio from 'material-components-vue/dist/radio'
Vue.use(MRadio)

export default {
  props: {
    handleRadioClick: {
      required: true,
      type: Function
    },
    name: {
      required: true,
      type: String
    },
    selectedVal: {
      default: null,
      required: false,
      type: [String, Object, Number, Boolean]
    },
    value: {
      required: true,
      type: [String, Object, Number, Boolean]
    }
  }
}
</script>
<style lang="scss">
@import 'material-components-vue/dist/radio/styles';
@import '../../universal/vars.scss';
@import "@material/radio/_mixins.scss";

.mdc-radio {
  @include mdc-radio-ink-color($mdc-theme-primary);
  @include mdc-radio-checked-stroke-color($mdc-theme-primary);
}
</style>
